import Vue, { VueConstructor } from "vue";
import SequenceHandler, { StringSequence, ISequence, FmdCodeSequence } from "./sequenceHandler";


class ShortcutCommand {
    public keySequence: Array<string>;
    public parameter: string;
    public element: any;
    public title: string;
    public description: string;
    public push: boolean;
    public once: boolean;
}


export default class {
    private _downKeys: Array<string>;
    public _availableCommands: { [shortcut: string]: ShortcutCommand; } = {}
    private objAvoided: Array<any>
    private _commandMode: boolean = false;
    private _sequenceHandler: SequenceHandler;
    //private _commandDetectionRunning: boolean = false;
    private _commandModeIndex: number = 0;
    private _fmdCallback: (seq: string) => void;


    constructor(fmdcallback: (seq: string) => void) {
        this.initialize();
        this._fmdCallback = fmdcallback;    
        this._downKeys = new Array<string>();
        this.objAvoided = new Array<any>();
    }

    public install(Vue: VueConstructor<Vue>, options: any): void {
        // We call Vue.mixin() here to inject functionality into all components.
        Vue.directive('shortkey', {
            bind: (el: any, binding: any, vnode: any) => {
                // Mapping the commands
                this.bindValue(binding.value.keys, el, binding, vnode)
            },

            update: (el, binding, vnode) => {
                const oldValue = binding.oldValue.keys
                this.unbindValue(oldValue, el)
                const newValue = binding.value.keys
                this.bindValue(newValue, el, binding, vnode)
            },

            unbind: (el, binding) => {
                const value = binding.value.keys
                this.unbindValue(value, el)
            }
        })
    }

    getSequences(): Array<ISequence> {
        var result = Object.keys(this._availableCommands).map(key => new StringSequence(key, this._availableCommands[key].element)) as Array<ISequence>
        //result.push(new FmdCodeSequence(this._fmdCallback));
        return result;
    }

    bindValue(value: string, el: any, binding: any, vnode: any) {

        const push = binding.modifiers.push === true
        const avoid = binding.modifiers.avoid === true
        const focus = !binding.modifiers.focus === true
        const once = binding.modifiers.once === true

        if (avoid) {
            this.objAvoided = this.objAvoided.filter((itm) => {
                return !itm === el;
            })
            this.objAvoided.push(el)
        }
        else {
            //console.log("Bind : ", value, el, binding, vnode);
            var shortcutCommand = new ShortcutCommand();
            if (value) {
                shortcutCommand.keySequence = value.split(",");
            }
            shortcutCommand.element = el;
            shortcutCommand.description = binding.value.description;
            shortcutCommand.title = binding.value.title;

            this._availableCommands[value] = shortcutCommand;
            this._sequenceHandler = new SequenceHandler(this.getSequences())
            //console.log("Available Commands after BINDING: " + value, this._availableCommands);
        }
    }

    unbindValue(value: string, el: any) {
        if (!el || el == undefined) return;
        //console.log("UnBind : " + value + this._availableCommands.length, el );
        for (var key of Object.keys(this._availableCommands)) {
            if (this._availableCommands[key].element == el) {
                delete this._availableCommands[key];
                //console.log("Unbind Key : " + key, this._availableCommands.length);
            }
        }

        this._sequenceHandler = new SequenceHandler(this.getSequences())
        //console.log("Available Commands after unbinding: ", this._availableCommands);
    }

    
    initialize() {
        return;

        //document.addEventListener('keydown', (pKey) => {
        //    //console.log("keydown : " + pKey.key );
        //    if (!(this._commandMode || !this.avoidElement(pKey))) {
        //        //console.log("Command " + pKey.key + "is ignored!");
        //        return;
        //    }
        //    if (pKey.key.toLowerCase() == "alt" || pKey.key.toLowerCase() == "shift") {
        //        //console.log("Modfier Key press ignored : " + pKey.key );
        //        return;
        //    } 

        //    if (this._downKeys.some(k => k == pKey.key)) {
        //        return;
        //    }
        //    this._downKeys.push(pKey.key)

        //    //console.log("Key Down : " + pKey.key)
        //    if (pKey.key.toLowerCase() == "control") {
        //        this.checkCommandMode();
        //    }
        //    else {
        //        var key = this.encodeKey(pKey);
        //        //console.log("Command Key : " + key, pKey)
        //        var result = this._sequenceHandler.processKey(key);
        //        if (result >= 0) {
        //            pKey.preventDefault();
        //            pKey.stopPropagation();
        //        }
        //    }
        //})

        //document.addEventListener('keyup', (pKey) => {
        //    var index = this._downKeys.indexOf(pKey.key);
        //    if (index > -1) {
        //        this._downKeys.splice(index, 1);
        //    }
        //});
    }


    encodeKey(pKey: KeyboardEvent) {

        var modifiers = [];
        if (pKey.altKey) modifiers.push('alt');
        if (pKey.ctrlKey) modifiers.push('ctrl');
        if (pKey.metaKey) modifiers.push('meta');
        if (pKey.shiftKey) modifiers.push('shift');

        var modifier = modifiers.sort().join('');

        var key = pKey.key.toLowerCase();
        //https://stackoverflow.com/questions/45433810/event-key-is-undefined-in-mobile-browsers-for-keyup-keydown-and-keypress
        if (key =="unidentified") {
            var currentCode = (pKey.which || pKey.keyCode) as number;
            key = String.fromCharCode(currentCode);
        }

        //console.log(pKey.key)
        if (!modifier)
            return key;

        else if (modifier != key)
            return modifier + "+" + key;
        else
            return modifier;
    }

    checkCommandMode() {
        ////console.log("checkCommandMode : " + this._commandModeIndex)
        if (this._commandMode)
            return;

        if (this._commandModeIndex == 0) {
            this._commandModeIndex = 1;
            setTimeout(() => { this._commandModeIndex = 0 }, 300);
        }
        else if (this._commandModeIndex == 1) {
            this._commandMode = true;
            //console.log("Command mode started")
            this._commandModeIndex = 0;
            setTimeout(() => {
                //console.log("Command mode stopped")
                this._commandMode = false;
            }, 2000);
        }
    }

    avoidElement(pKey: KeyboardEvent): boolean {
        if (pKey.srcElement != null)
            return pKey.srcElement.nodeName == "INPUT";
        else
            return true;
    }
}


// WEBPACK FOOTER //
// ./ClientApp/scripts/shortkeyV2.ts